import React, { useEffect, useMemo, useState, createContext, useContext } from "react";

export const ThemeContext = createContext({
  theme: "dark",
  setTheme: () => { },
  toggle: () => { },
});

export function useTheme() {
  return useContext(ThemeContext);
}

export default function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      const saved = window.localStorage.getItem("theme");
      return saved === "day" || saved === "dark" ? saved : "dark";
    } catch {
      return "dark";
    }
  });

  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute("data-theme", theme);

    if (theme === "dark") html.classList.add("dark");
    else html.classList.remove("dark");

    try {
      window.localStorage.setItem("theme", theme);
    } catch { }
  }, [theme]);

  const value = useMemo(
    () => ({
      theme,
      setTheme,
      toggle: () => setTheme((t) => (t === "day" ? "dark" : "day")),
    }),
    [theme]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
